import { Text, Title } from '@mantine/core';
import type { ReactNode } from 'react';

export function FormHeader({
  eyebrow,
  title,
  subtitle,
}: {
  eyebrow?: ReactNode;
  title: string;
  subtitle: string;
}) {
  return (
    <div style={{ marginBottom: 28 }}>
      {eyebrow ? (
        <Text
          size="xs"
          fw={600}
          tt="uppercase"
          c="brand.7"
          mb={8}
          style={{ letterSpacing: '0.06em' }}
        >
          {eyebrow}
        </Text>
      ) : null}
      <Title order={2} fz={26} mb={6}>
        {title}
      </Title>
      <Text c="dimmed" fz="sm">
        {subtitle}
      </Text>
    </div>
  );
}
